import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetApproversApi } from "../../../api/approvals/GetApproversApi";
import CreateDesignationApi from "../../../api/CreateDesignationApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
const { Option } = Select;

function AddDesignationModal(props) {
  const [submit, setSubmit] = useState(false);
  const positionState = useSelector((state) => state.positionState.value);
  const [approvers, setApprovers] = useState([]);

  useEffect(() => {
    if (props.visible) {
      getApprovers();
    }
  }, [props.visible]);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreateDesignationApi(
      values.name,
      values.abbreviation,
      positionState.id,
      positionState?.userRole?.name === "Manager"
        ? values.approver
        : positionState.id
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Designation added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add designations. Try again later."
      );
    }
    handleCancel();
  }

  async function getApprovers() {
    const apiResponse = await GetApproversApi(positionState?.id);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      setApprovers(apiResponse?.data);
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit approver. Try again later."
      );
    }
  }

  return (
    <Modal
      title="Add new designation"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addDesignation"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Designation name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter designation name!",
            },
          ]}
        >
          <Input placeholder="Designation name" />
        </Form.Item>

        <Form.Item
          label="Abbreviation"
          name="abbreviation"
          rules={[
            {
              required: true,
              message: "Please enter abbreviation!",
            },
          ]}
        >
          <Input placeholder="Abb" />
        </Form.Item>
        {positionState?.userRole?.name === "Manager" && (
          <Form.Item
            label="Approver"
            name="approver"
            rules={[
              {
                required: true,
                message: "Please select approver!",
              },
            ]}
          >
            <Select
              allowClear
              showSearch
              placeholder="Select approver"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {approvers?.map((approver) => {
                return (
                  <Option key={approver?.id} value={approver?.id}>
                    {(approver?.designations?.abbreviation ||
                      approver?.designations?.name) +
                      "," +
                      approver?.units?.name}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        )}

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-40"
              type="primary"
              disabled={submit}
              htmlType={submit && "submit"}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddDesignationModal;
